import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { listTenantsListenerSaga } from './list-tenants';
import { selectTenantListenerSaga } from './select-tenant';

export function* rootSaga(): SagaIterator {
    yield all([fork(listTenantsListenerSaga), fork(selectTenantListenerSaga)]);
}
